import { render, staticRenderFns } from "./ButtonTasklist.vue?vue&type=template&id=281d4322"
import script from "./ButtonTasklist.vue?vue&type=script&lang=ts"
export * from "./ButtonTasklist.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports